"use client";

import { motion, useReducedMotion } from "framer-motion";

import { cn } from "@/lib/utils";

import { HERO_SLIDE_POPOVER } from "@/features/home/components/hero-slides/hero-slide-theme.constants";

import type { MockupFloatingCardProps } from "./MockupScene.types";

export const MockupFloatingCard = ({
  children,
  className,
  delay = 0,
}: MockupFloatingCardProps) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.div
      className={cn(HERO_SLIDE_POPOVER, "relative p-3", className)}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: prefersReducedMotion ? 0 : [0, -3, 0] }}
      transition={{
        opacity: { duration: 0.45, delay },
        y: { duration: 5 + delay, repeat: Infinity, ease: "easeInOut", delay },
      }}
    >
      {children}
    </motion.div>
  );
};
